/* Scroll reveal — see snippets/ir-reveal-assets.liquid for the markup API. */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('ir-reveal-ready')) return;
  window.__irReveal = true;

  var STAGGER = 90;
  var MAX_STAGGER = 400;
  // Longest reveal chain (timeline line + steps) finishes well inside this.
  var SETTLE = 2200;

  function show(el, delay) {
    var total = delay + (parseInt(el.getAttribute('data-reveal-delay'), 10) || 0);
    el.style.setProperty('--reveal-delay', total + 'ms');
    el.classList.add('is-visible');
    // Drop the reveal transition afterwards so the element's own hover
    // transitions apply again.
    setTimeout(function () {
      el.classList.add('reveal-done');
    }, total + SETTLE);
  }

  var observer = new IntersectionObserver(
    function (entries) {
      var batch = entries
        .filter(function (e) { return e.isIntersecting; })
        .map(function (e) { return e.target; });
      // Stagger only what arrives together, in reading order, so a card that
      // scrolls in alone on mobile doesn't wait for siblings already shown.
      batch.sort(function (a, b) {
        return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
      });
      batch.forEach(function (el, i) {
        observer.unobserve(el);
        show(el, Math.min(i * STAGGER, MAX_STAGGER));
      });
    },
    // Fires once the element's top is 12% above the bottom of the screen.
    // Edge-based rather than a visible-ratio threshold, so very tall blocks
    // (long article bodies) still trigger.
    { threshold: 0, rootMargin: '0px 0px -12% 0px' }
  );

  function scan(scope) {
    scope.querySelectorAll('[data-reveal]:not(.is-visible)').forEach(function (el) {
      // Already scrolled past (e.g. reload mid-page): show without animating.
      if (el.getBoundingClientRect().bottom < 0) {
        el.classList.add('is-visible', 'reveal-done');
        return;
      }
      observer.observe(el);
    });
  }

  scan(document);
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();
